module.exports = __webpack_public_path__ + "img/pedido.93a8bbaf.png";